/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IncidentFollowupListEntry } from './IncidentFollowupListEntry';
import {
    IncidentFollowupListEntryFromJSON,
    IncidentFollowupListEntryFromJSONTyped,
    IncidentFollowupListEntryToJSON,
} from './IncidentFollowupListEntry';
import type { PostIncidentCommentEntry } from './PostIncidentCommentEntry';
import {
    PostIncidentCommentEntryFromJSON,
    PostIncidentCommentEntryFromJSONTyped,
    PostIncidentCommentEntryToJSON,
} from './PostIncidentCommentEntry';

/**
 * 
 * @export
 * @interface IncidentFormFindOneResponse
 */
export interface IncidentFormFindOneResponse {
    /**
     * 
     * @type {string}
     * @memberof IncidentFormFindOneResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentFormFindOneResponse
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IncidentFormFindOneResponse
     */
    assigned_to?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof IncidentFormFindOneResponse
     */
    deadline: Date;
    /**
     * 
     * @type {string}
     * @memberof IncidentFormFindOneResponse
     */
    created_by?: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentFormFindOneResponse
     */
    completed_by?: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentFormFindOneResponse
     */
    cancelled_by?: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentFormFindOneResponse
     */
    completed_date?: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentFormFindOneResponse
     */
    s3_key?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IncidentFormFindOneResponse
     */
    is_started: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IncidentFormFindOneResponse
     */
    is_optional: boolean;
    /**
     * 
     * @type {string}
     * @memberof IncidentFormFindOneResponse
     */
    cancellation_reason?: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentFormFindOneResponse
     */
    completion_note?: string;
    /**
     * 
     * @type {Array<PostIncidentCommentEntry>}
     * @memberof IncidentFormFindOneResponse
     */
    comments: Array<PostIncidentCommentEntry>;
    /**
     * 
     * @type {string}
     * @memberof IncidentFormFindOneResponse
     */
    incomplete_followup_time?: string;
    /**
     * 
     * @type {Array<IncidentFollowupListEntry>}
     * @memberof IncidentFormFindOneResponse
     */
    followups: Array<IncidentFollowupListEntry>;
    /**
     * 
     * @type {any}
     * @memberof IncidentFormFindOneResponse
     */
    complete_followups: any | null;
}

/**
 * Check if a given object implements the IncidentFormFindOneResponse interface.
 */
export function instanceOfIncidentFormFindOneResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "deadline" in value;
    isInstance = isInstance && "is_started" in value;
    isInstance = isInstance && "is_optional" in value;
    isInstance = isInstance && "comments" in value;
    isInstance = isInstance && "followups" in value;
    isInstance = isInstance && "complete_followups" in value;

    return isInstance;
}

export function IncidentFormFindOneResponseFromJSON(json: any): IncidentFormFindOneResponse {
    return IncidentFormFindOneResponseFromJSONTyped(json, false);
}

export function IncidentFormFindOneResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentFormFindOneResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'assigned_to': !exists(json, 'assigned_to') ? undefined : json['assigned_to'],
        'deadline': (new Date(json['deadline'])),
        'created_by': !exists(json, 'created_by') ? undefined : json['created_by'],
        'completed_by': !exists(json, 'completed_by') ? undefined : json['completed_by'],
        'cancelled_by': !exists(json, 'cancelled_by') ? undefined : json['cancelled_by'],
        'completed_date': !exists(json, 'completed_date') ? undefined : json['completed_date'],
        's3_key': !exists(json, 's3_key') ? undefined : json['s3_key'],
        'is_started': json['is_started'],
        'is_optional': json['is_optional'],
        'cancellation_reason': !exists(json, 'cancellation_reason') ? undefined : json['cancellation_reason'],
        'completion_note': !exists(json, 'completion_note') ? undefined : json['completion_note'],
        'comments': ((json['comments'] as Array<any>).map(PostIncidentCommentEntryFromJSON)),
        'incomplete_followup_time': !exists(json, 'incomplete_followup_time') ? undefined : json['incomplete_followup_time'],
        'followups': ((json['followups'] as Array<any>).map(IncidentFollowupListEntryFromJSON)),
        'complete_followups': json['complete_followups'],
    };
}

export function IncidentFormFindOneResponseToJSON(value?: IncidentFormFindOneResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'assigned_to': value.assigned_to,
        'deadline': (value.deadline.toISOString()),
        'created_by': value.created_by,
        'completed_by': value.completed_by,
        'cancelled_by': value.cancelled_by,
        'completed_date': value.completed_date,
        's3_key': value.s3_key,
        'is_started': value.is_started,
        'is_optional': value.is_optional,
        'cancellation_reason': value.cancellation_reason,
        'completion_note': value.completion_note,
        'comments': ((value.comments as Array<any>).map(PostIncidentCommentEntryToJSON)),
        'incomplete_followup_time': value.incomplete_followup_time,
        'followups': ((value.followups as Array<any>).map(IncidentFollowupListEntryToJSON)),
        'complete_followups': value.complete_followups,
    };
}

